.error-message-container {
    min-height: 40px;
    padding-bottom: 16px;
    display: flex;
    align-items: flex-end;
    width: 100%;
}
